import '../rcs_cor_notification-footer-bar.style.scss';
import CONFIG from 'config';
import RcsUtils from '../utils/RcsUtils';
import FetchUtils from '../utils/FetchUtils';
import ArticleDetail from '../utils/ArticleDetail';

class NotificationFooterBar {
  /**
   * This constructor initialize all the necessary variables.
   * @param element DOMElement Element used to render everything
   * @param options Object of component parameters
   */
  constructor(options = {}) {
    this.container = document.querySelector('[data-notifications-footer-bar]');
    this.apiPrefix = options.apiPrefix || CONFIG.apiPrefix;
  }

  /**
   * Fetch data and render the component.
   */
  render() {
    if (this.container === null) {
      return;
    }

    this.eventListeners();
  }

  /**
   * Fetch data from a URL.
   * @param url
   * @param callback
   * @returns {Promise<string>}
   */
  fetch(url, callback) {
    return fetch(url)
      .then(response => {
        if (!response.ok) {
          throw Error(response.statusText);
        }
        return response.arrayBuffer();
      })
      .then(data => callback(data))
      .catch(error => {
        throw new Error(`Failed fetching data. Reason: ${error}`);
      });
  }

  /**
   * Start the Event Listeners for the DOM.
   */
  eventListeners() {
    let container = this.container;

    let videoElement = container.querySelector('.video a');
    if (videoElement !== null) {
      videoElement.addEventListener('click', e => {
        e.preventDefault();
        let url = videoElement.getAttribute('href');
        window.location.href = url;
      });
    }

    let fragmentsElements = Array.from(container.querySelectorAll('[data-fragment]'));
    fragmentsElements.forEach(fragmentsElement => {
      fragmentsElement.addEventListener('click', e => {
        e.preventDefault();
        let fragment = fragmentsElement.getAttribute('data-fragment');

        if (fragment === 'video') {
          return;
        }

        fragmentsElements.forEach(innerfragmentsElement => {
          RcsUtils.removeClass(innerfragmentsElement, 'swiper-pagination-bullet-active');
        });

        let swiperSlideElements = Array.from(
          document.querySelectorAll('.main-content .swiper-slide')
        );
        if (swiperSlideElements !== null) {
          swiperSlideElements.forEach(swiperSlideElement => {
            swiperSlideElement.style.display = 'none';
          });
        }

        let mainContentFragmentElement = document.querySelector(
          `.main-content #${fragment}`
        );
        if (mainContentFragmentElement !== null) {
          RcsUtils.removeClass(mainContentFragmentElement, 'active');
          mainContentFragmentElement.style.display = 'block';
        }

        let freeZoneElement = document.querySelector('.zonalibera');
        if (freeZoneElement !== null) {
          if (fragment === 'news') {
            freeZoneElement.style.display = 'block';
          } else {
            freeZoneElement.style.display = 'none';
          }
        }

        this.initTab(fragment);

        RcsUtils.addClass(fragmentsElement, 'swiper-pagination-bullet-active');
        RcsUtils.addClass(mainContentFragmentElement, 'active');
      });
    });
  }

  /**
   * Change the view based on fragment clicked.
   * @param nameTab
   */
  initTab(nameTab) {
    if (nameTab === 'news') {
      return;
    }

    let mainFragmentElement = document.querySelector(`.main-content #${nameTab}`);

    if (mainFragmentElement === null) {
      return;
    }

    let fragmentDetail;
    let fragmentsMapping = {
      opinioni: {
        url: '/includes_methode/cache/opinioni_mobile.shtml',
        index: 1
      },
      inchieste: {
        url: '/includes_methode/cache/inchieste_mobile.shtml',
        index: 2
      },
      societa: {
        url: '/includes_methode/cache/societa_mobile.shtml',
        index: 3
      }
    };

    if (typeof fragmentsMapping[nameTab] === 'undefined') {
      return;
    }
    fragmentDetail = fragmentsMapping[nameTab];

    mainFragmentElement.style.minHeight = '500px';
    let requestUrl = `${this.apiPrefix}${fragmentDetail.url}`;

    this.fetch(requestUrl, data => {
      let html = FetchUtils.arrayBufferToString(data);
      mainFragmentElement.innerHTML = html;
      RcsUtils.applyLazyLoad();
      let container = document.querySelector(`.main-content #${nameTab} .md_mobile`);
      ArticleDetail.detailArt(container);
      RcsUtils.triggerEvent('hpNotificationFooterBarTabLoaded', document, {
        tabName: nameTab
      });
    });
  }
}

module.exports = NotificationFooterBar;



// WEBPACK FOOTER //
// ./src/rcs_cor_hp-lazy-loading/boxes/NotificationFooterBar.js